import React from "react";

const DashboardHome = () => {
  return (
    <div>
      <h1>Welcome to the Dashboard !</h1>
    </div>
  );
};

export default DashboardHome;
